import { asInstant, mapObjectList, optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.content.AssigneeHistory
 *
 * @typedef {object} AssigneeHistoryData
 * @property {string|null} assigneeId
 * @property {string|null} userId
 * @property {number|string|null} timestamp
 */

/**
 * @param {object} raw
 * @returns {AssigneeHistoryData}
 */
export function fromAssigneeHistoryData(raw) {
  const source = requireObject(raw, 'AssigneeHistory');
  return {
    assigneeId: optionalString(source.assigneeId),
    userId: optionalString(source.userId),
    timestamp: asInstant(source.timestamp),
  };
}

/**
 * @param {unknown} raw
 * @returns {AssigneeHistoryData[]}
 */
export function fromAssigneeHistoryDataList(raw) {
  return mapObjectList(raw, fromAssigneeHistoryData);
}
